import { Outlet } from "react-router-dom";
import HeaderDashboard from "../components/header/HeaderDashboard";
import StoreDashboardSideBarDrawer from "../components/drawer/StoreDashboardSideBarDrawer";
import { motion } from "framer-motion";
import { childVariants } from "../animation/RoutesAnimations";
function DashboardLayout() {
  return (
    <motion.div
      variants={childVariants}
      initial="initial"
      animate="final"
      className="flex min-h-screen relative bg-gray-100"
    >
      <StoreDashboardSideBarDrawer />
      <div className="flex flex-col w-screen">
        <div className="bg-white">
          <HeaderDashboard />
        </div>
        <div className="max-w-[2800px]">
          <Outlet />
        </div>
      </div>
    </motion.div>
  );
}

export default DashboardLayout;
